<template>
  <div class="big-box" v-if="isShowHelp && !isMobile" @contextmenu.stop>
    <div class="help-container">
      <div class="help-wrap">
        <div class="first-son">
          <img src="@imgs/close2x.png" alt="" @click="handleClose" />
        </div>
        <div class="two-son">
          <div class="left">
            <img src="@imgs/sj2x.png" alt="" />
          </div>
          <div class="right">
            <h1>鼠标双击</h1>
            <p class="text-style">
              <span>1.&nbsp;</span>
              <span>原始版面下，双击鼠标开启缩放模式</span>
            </p>
            <p class="text-style">
              <span>2.&nbsp;</span>
              <span>缩放模式下，双击鼠标退出缩放模式</span>
            </p>
          </div>
        </div>
        <div class="three-son">
          <div class="left">
            <img src="@imgs/wheel2x.png" alt="" />
          </div>
          <div class="right">
            <h1>滑动鼠标滚轮</h1>
            <p class="text-style">
              <span>1.&nbsp;</span>
              <span>原始版面下可实现翻页</span>
            </p>
            <p class="text-style">
              <span>2.&nbsp;</span>
              <span>缩放模式下，可用于调节书刊显示比例，展示书刊细节</span>
            </p>
          </div>
        </div>
        <div class="four-son">
          <button @click="handleClose">我已了解</button>
        </div>
        <div class="five-son">
          您可通过下方操作栏解锁更多实用技能&nbsp;&nbsp;↓
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Help',
  data() {
    return {}
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    isShowHelp() {
      return this.$store.state.book.isShowHelp
    }
  },
  methods: {
    handleClose() {
      // $('.big-box').hide()
      this.$store.commit('book/UPDATE_IS_SHOW_Help', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.big-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20000;
}
.help-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  left: 0;
  top: 0;
  .help-wrap {
    width: 400px;
    height: 400px;
    background: rgba(0, 0, 0, 0.85);
    border-radius: 13px;
    position: absolute;
    .first-son {
      width: 100%;
      height: 35px;
      margin-top: 5px;
      img {
        width: 35px;
        height: 35px;
        float: right;
        margin-right: 5px;
        cursor: pointer;
      }
    }
    .two-son,
    .three-son {
      width: 328px;
      margin-left: 34px;
      display: flex;
      .left {
        width: 53px;
        height: 67px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        margin-left: 23px;
        h1 {
          font-size: 16px;
          font-weight: 500;
          color: #fff;
          line-height: 16px;
        }
        p {
          width: 239px;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          text-align: justify;
          text-justify: newspaper;
          word-break: break-all;
          margin: 0;
          // line-height: 14px;
        }
        // .p {
        //   text-indent: -10px;
        //   margin-left: 10px;
        // }
        .text-style {
          display: -webkit-flex;
          display: flex;
          align-items: flex-start;
        }
      }
    }
    .two-son .left {
      margin-top: 10px;
    }
    .three-son {
      margin-top: 21px;
    }
    .four-son {
      width: 100%;
      height: 40px;
      text-align: center;
      line-height: 40px;
      margin-top: 38px;
      button {
        width: 133px;
        height: 40px;
        background: #ffffff;
        border-radius: 9px;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        border: 0;
        outline: none;
        cursor: pointer;
      }
    }
    .five-son {
      width: 100%;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      margin-top: 18px;
    }
  }
}
</style>
